<template>
	<v-sheet elevation="0">
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="pageTitle">
			<!-- これは使わない -->
			<template v-slot:app-bar-btn>
				<v-switch
					dark
					v-model="singleColumn"
					color="white"
					:label="singleColumn ? '2列表示にする' : '1列表示にする'"
					hide-details
				/>
				<v-switch
					class="ml-2"
					dark
					v-model="allRequired"
					color="white"
					:label="allRequired ? '任意項目にする' : '必須項目にする'"
					hide-details
				/>
			</template>

			<v-form ref="form" v-model="valid">
				<v-row no-gutters>
					<v-col :class="singleColumn || $vuetify.breakpoint.xs ? '' : 'pr-2'" :cols="cols">
						<!-- テキストフィールド -->
						<v-text-field
							:label="allRequired ? 'テキスト(必須)' : 'テキスト'"
							dense
							outlined
							:rules="allRequired ? [rules.required] : []"
							class="mt-4"
							hint="ここにヒントを表示"
						/>

						<!-- セレクト -->
						<v-select
							:label="allRequired ? 'セレクト(必須)' : 'セレクト'"
							:items="items"
							item-text="name"
							item-value="id"
							:rules="allRequired ? [rules.required] : []"
							hint="ここにヒントを表示"
							no-data-text="ここにデータがない時の文章"
							class="mt-4"
							outlined
							dense
						/>
						<!-- マルチセレクト -->
						<v-select
							:label="allRequired ? 'マルチセレクト(必須)' : 'マルチセレクト'"
							:items="items"
							item-text="name"
							item-value="id"
							:rules="allRequired ? [rules.required] : []"
							hint="ここにヒントを表示"
							no-data-text="ここにデータがない時の文章"
							class="mt-4"
							multiple
							outlined
							dense
						/>
						<!-- マルチセレクト チップ表示 -->
						<v-select
							:label="allRequired ? 'マルチセレクト チップ表示(必須)' : 'マルチセレクト チップ表示'"
							:items="items"
							item-text="name"
							item-value="id"
							:rules="allRequired ? [rules.required] : []"
							hint="ここにヒントを表示"
							no-data-text="ここにデータがない時の文章"
							class="mt-4"
							multiple
							outlined
							chips
							small-chips
							dense
						/>
						<!-- コンボボックス -->
						<v-combobox
							:label="allRequired ? 'コンボボックス(必須)' : 'コンボボックス'"
							:items="items"
							item-text="name"
							item-value="id"
							:rules="allRequired ? [rules.required] : []"
							hint="ここにヒントを表示"
							no-data-text="ここにデータがない時の文章"
							class="mt-4"
							outlined
							dense
						/>
						<!-- ラジオボタン群 ラベルが不必要な場合は消して、v-radio-group class="mt-1"を削除 -->
						<div class="mt-4">
							<label class="text-body-2 font-weight-bold">{{
								allRequired ? "ラジオボタン(必須)" : "ラジオボタン"
							}}</label>
							<v-radio-group
								class="mt-1"
								row
								:rules="allRequired ? [rules.required] : []"
								hint="ここにヒントを表示"
							>
								<v-radio
									v-for="item in items"
									:label="item.name"
									:key="item.id"
									:value="item.id"
									class="mr-2"
									dense
								/>
							</v-radio-group>
						</div>

						<!-- チェックボックス群 ラベルが不必要な場合は削除 -->
						<div class="mt-4">
							<label class="text-body-2 font-weight-bold">{{
								allRequired ? "チェックボックス(必須)" : "チェックボックス"
							}}</label>
							<v-row no-gutters class="mt-1 checkbox-wrapper">
								<v-checkbox
									v-model="multi"
									v-for="(item, i) in items"
									:label="item.name"
									:key="item.id"
									:value="item.id"
									:rules="allRequired ? [rules.required] : []"
									:hide-details="i != 0"
									class="mr-2"
									dense
								/>
							</v-row>
						</div>
					</v-col>

					<v-col :class="singleColumn || $vuetify.breakpoint.xs ? '' : 'pl-2'" :cols="cols">
						<!-- 日付セレクト -->
						<div class="mt-4">
							<label class="text-body-2 font-weight-bold">{{
								allRequired ? "日付(必須)" : "日付"
							}}</label>
							<v-row class="mt-2" no-gutters>
								<v-col class="pr-1" sm="4">
									<v-select
										dense
										outlined
										:items="years"
										:rules="allRequired ? [rules.required] : []"
									>
										<template v-slot:append-outer>年</template>
									</v-select>
								</v-col>
								<v-col class="px-1" sm="4">
									<v-select
										dense
										outlined
										:items="months"
										:rules="allRequired ? [rules.required] : []"
									>
										<template v-slot:append-outer>月</template>
									</v-select>
								</v-col>
								<v-col class="pl-1" sm="4">
									<v-select
										dense
										outlined
										:items="days"
										:rules="allRequired ? [rules.required] : []"
									>
										<template v-slot:append-outer>日</template>
									</v-select>
								</v-col>
							</v-row>
						</div>

						<!-- 日付(DatePicker) -->
						<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									class="mt-4"
									:label="allRequired ? '日付(必須)' : '日付'"
									required
									readonly
									outlined
									dense
									:rules="allRequired ? [rules.required] : []"
									v-bind="attrs"
									v-on="on"
									hint="ここにヒントを表示"
								/>
							</template>
							<v-date-picker no-title locale="ja-JP" />
						</v-menu>

						<!-- 時間(TextField) -->
						<v-text-field
							:label="allRequired ? '時間(必須)' : '時間'"
							type="time"
							dense
							outlined
							:rules="allRequired ? [rules.required] : []"
							class="mt-4"
							hint="ここにヒントを表示"
						/>

						<!-- 日時セレクト -->
						<div class="mt-4">
							<label class="text-body-2 font-weight-bold">{{
								allRequired ? "日時(必須)" : "日時"
							}}</label>
							<v-row class="mt-2" no-gutters>
								<v-col
									:class="singleColumn && $vuetify.breakpoint.mdAndUp ? 'pr-1' : ''"
									cols="12"
									:sm="singleColumn && $vuetify.breakpoint.mdAndUp ? '6' : '12'"
								>
									<v-row no-gutters>
										<v-col class="pr-1" cols="4">
											<v-select
												dense
												outlined
												:items="years"
												:rules="allRequired ? [rules.required] : []"
											>
												<template v-slot:append-outer>年</template>
											</v-select>
										</v-col>
										<v-col class="px-1" cols="4">
											<v-select
												dense
												outlined
												:items="months"
												:rules="allRequired ? [rules.required] : []"
											>
												<template v-slot:append-outer>月</template>
											</v-select>
										</v-col>
										<v-col class="pl-1" cols="4">
											<v-select
												dense
												outlined
												:items="days"
												:rules="allRequired ? [rules.required] : []"
											>
												<template v-slot:append-outer>日</template>
											</v-select>
										</v-col>
									</v-row>
								</v-col>
								<v-col
									:class="singleColumn && $vuetify.breakpoint.mdAndUp ? 'pl-1' : ''"
									cols="12"
									:sm="singleColumn && $vuetify.breakpoint.mdAndUp ? '6' : '12'"
								>
									<v-row no-gutters>
										<v-col class="pr-1" cols="4">
											<v-select
												dense
												outlined
												:items="hours"
												:rules="allRequired ? [rules.required] : []"
											>
												<template v-slot:append-outer>時</template>
											</v-select>
										</v-col>
										<v-col class="px-1" cols="4">
											<v-select
												dense
												outlined
												:items="minutes"
												:rules="allRequired ? [rules.required] : []"
											>
												<template v-slot:append-outer>分</template>
											</v-select>
										</v-col>
										<v-col class="pl-1" cols="4">
											<v-select
												dense
												outlined
												:items="seconds"
												:rules="allRequired ? [rules.required] : []"
											>
												<template v-slot:append-outer>秒</template>
											</v-select>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
						</div>

						<!-- テキストエリア -->
						<v-textarea
							class="mt-4"
							:label="allRequired ? 'テキストエリア(必須)' : 'テキストエリア'"
							:rules="allRequired ? [rules.required] : []"
							hint="ここにヒントを表示"
							outlined
							dense
						/>


						<v-row no-gutters class="mt-4" justify="space-between">
							<h6 class="text-h6 font-weight-bold">1対多のフォーム</h6>
							<v-btn color="secondary" @click="multipleItems += 1">フォームを追加</v-btn>
						</v-row>
						<v-text-field
							v-for="n of multipleItems"
							:key="n"
							:label="allRequired ? 'テキスト(必須)' : 'テキスト'"
							dense
							outlined
							:rules="allRequired ? [rules.required] : []"
							class="mt-4"
							hint="ここにヒントを表示"
						/>
					</v-col>
				</v-row>
				<v-row no-gutters class="my-4" justify="center">
					<v-btn color="secondary" @click="validateForm" :disabled="valid">
						<v-icon class="mr-2">mdi-plus</v-icon>
						登録する
					</v-btn>
				</v-row>
			</v-form>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import rules from "../../helper/rules"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"

export default {
	components: {
		FunctionTitle,
		CommonFlame,
	},
	data() {
		return {
			mainTitle: "部門名・項目名",
			pageTitle: "SampleNewPage.vue",
			rules: rules,
			multi: [],
			singleColumn: true,
			allRequired: false,
			multipleItems: 0,
			valid: false,
		}
	},
	methods: {
		validateForm() {
			this.$refs.form.validate()
		},
	},
	computed: {
		items() {
			const array = []
			for (let i = 0; i < 5; i++) {
				array.push({ id: i, name: `項目${i}` })
			}
			return array
		},
		cols() {
			if (this.$vuetify.breakpoint.xs) {
				return "12"
			}
			if (this.singleColumn) {
				return "12"
			} else {
				return "6"
			}
		},
		years() {
			const thisYear = new Date().getFullYear()
			const endYear = 1900
			const years = [...Array(thisYear - endYear + 1)].map((_, i) => thisYear - i)
			return years
		},
		months() {
			const months = [...Array(12)].map((_, i) => i + 1)
			return months
		},
		days() {
			const days = [...Array(31)].map((_, i) => i + 1)
			return days
		},
		hours() {
			const hours = [...Array(24)].map((_, i) => i)
			return hours
		},
		minutes() {
			const days = [...Array(60)].map((_, i) => i)
			return days
		},
		seconds() {
			const days = [...Array(60)].map((_, i) => i)
			return days
		},
	},
}
</script>